import dayjs from 'dayjs'
import { DaylightDateFormat } from '@/constants/DaylightDateFormat'

/**
 * Mock Export Issues Data
 * Matches the actual API response structure
 */
export const mockExportIssues = {
  success: true,
  message: 'Issues exported successfully',
  data: [
    {
      Issue: 'AxiosError: Network Error',
      'Issue ID': '6843177808',
      'Short ID': 'APEX-CLIENT-8FN',
      Environment: 'PROD',
      'Last Seen': dayjs().subtract(2, 'hours').format(DaylightDateFormat.DATE_TIME_12),
      Age: '3 months',
      Events: 23,
      Users: 5,
      Priority: 'High',
    },
    {
      Issue: 'Request failed with status code 404',
      'Issue ID': '6843177809',
      'Short ID': 'APEX-CLIENT-9GH',
      Environment: 'PROD',
      'Last Seen': dayjs().subtract(30, 'minutes').format(DaylightDateFormat.DATE_TIME_12),
      Age: '1 month',
      Events: 156,
      Users: 8,
      Priority: 'High',
    },
    {
      Issue: 'TypeError: Cannot read properties of undefined',
      'Issue ID': '6843177810',
      'Short ID': 'APEX-CLIENT-1RP',
      Environment: 'LOCAL',
      'Last Seen': dayjs().subtract(1, 'hour').format(DaylightDateFormat.DATE_TIME_12),
      Age: '2 weeks',
      Events: 12,
      Users: 3,
      Priority: 'Medium',
    },
    {
      Issue: 'Request timeout exceeded',
      'Issue ID': '6843177811',
      'Short ID': 'APEX-CLIENT-ARD',
      Environment: 'QA',
      'Last Seen': dayjs().subtract(3, 'hours').format(DaylightDateFormat.DATE_TIME_12),
      Age: '1 week',
      Events: 8,
      Users: 2,
      Priority: 'Low',
    },
    {
      Issue: 'ChunkLoadError: Loading chunk failed',
      'Issue ID': '6843177812',
      'Short ID': 'APEX-CLIENT-BHM',
      Environment: 'PROD',
      'Last Seen': dayjs().subtract(15, 'minutes').format(DaylightDateFormat.DATE_TIME_12),
      Age: '5 days',
      Events: 45,
      Users: 10,
      Priority: 'Medium',
    },
  ],
  recordCount: 5,
}
